module.exports = __webpack_public_path__ + "img/Editor.c3a43ddd.svg";